export default __webpack_public_path__ + "static/media/864.1e77ce4e.gif";